import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateFeeStructureForm from "../../forms/CreateOrUpdateFeeStructureForm";

interface CreateFeeStructureModalProps {
  open: boolean;
  onClose: () => void;
  userInfo?: any;
  loading: boolean;
  error: string | null;
}

const CreateFeeStructureModal: React.FC<CreateFeeStructureModalProps> = ({
  open,
  onClose,
  userInfo,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Create Fee Structure"
    width="md"
    loading={loading}
  >
    <CreateOrUpdateFeeStructureForm
      loading={loading}
      userInfo={userInfo}
      error={error}
    />
  </AppModal>
);

export default CreateFeeStructureModal;
